import React from 'react';
import { connect } from 'react-redux';
import { isAuth } from 'lib/Helper';
import { Row, Col, BackTop, Breadcrumb, Alert, Badge } from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';
import { TableList } from 'components/list';
import { PageHeader } from 'components/header';
import SearchTable from 'components/search-table/SearchTable';
import columns from './Columns';
import useList from '../hooks/useList';
import AuthRedirect from 'components/AuthRedirect';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { SortingTableOnly } from 'components/sorting-table';
import Header from './Header';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}];

const PenilaianStatusNilaiDetail = ({ privilege, match }) => {
  const {
    action,
    headerData,
    table,
    fetchTable,
    fetchData,
  } = useList(privilege, match);

  if (!isAuth(privilege) || (action === undefined || action.detail === undefined)) {
    return <AuthRedirect />
  }
  return (
    <>
      <PageHeader
        style={{
          padding: 0
        }}
        onBack={() => window.history.back()}
        title={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
          <Breadcrumb.Item>Penilaian</Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/penilaian/status-nilai">Status NIlai</Link> </Breadcrumb.Item>
          <Breadcrumb.Item>Detail </Breadcrumb.Item>
        </Breadcrumb>}
      />

      <Alert type="info" message="Data bertanda merah menandakan bahwa pada rombel tersebut masih ada guru mapel yang belum mengirimkan penilaian. Silakan menghubungi guru terkait untuk segera menyelesaikan proses penilaian." />

      <Header data={headerData} />

      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>

        <PageHeader
          className="site-page-header"
          title="Detail Status Nilai" />

        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Badge color={"#ff000057"} text={"Guru mapel yang belum mengirimkan penilaian"} />
          </Col>

          <Col xs={24} sm={18} md={19}>
            <SearchTable table={table} fetch={fetchData} />
          </Col>
          <Col xs={24} sm={6} md={5}>
            <SortingTableOnly
              table={table}
              fetch={fetchData}
              sortFields={sortFields}
            />
          </Col>
          <Col xs={24}>
            <TableList
              isFetchFirst={false}
              state={{ table }}
              fetch={fetchData}
              fetchTable={fetchTable}
              columns={columns(action)}
            />
          </Col>
        </Row>
      </div>
      <BackTop />
    </>
  );
};

const mapStateToProps = (state) => ({
  privilege: state.privilege,
});

export default connect(mapStateToProps)(PenilaianStatusNilaiDetail);